// third-party
import { FormattedMessage } from "react-intl";
import stickyNoteIcon from "../assets/icons/avis.svg";

const icons = {
  avis: () => <img src={stickyNoteIcon} alt="expert icon" />,
};

const avis = {
  id: "avis",
  title: <FormattedMessage id="avisExpert" />,
  type: "group",
  url: "/avis",
  icon: icons.avis,
};

export default avis;
